module.exports = {
    // basic
    'last-password-change-date': 'fecha del último cambio de contraseña',
    'last-login-date': 'última fecha de inicio de sesión',
    'role-type': 'tipo de rol',
    'role-types': 'tipos de roles',
    'login-count': 'login count',
    
    // raw
    'well-users-company-help': `Ver la actividad de todos los usuarios de esta empresa en este pozo.`,
    'well-users-email-help': `Enviar a este usuario.`,
    'well-users-username-help': `Ver actividad de este usuario en este pozo.`,

    // template
};
